import styled from 'styled-components';

export const StyledTabRadioGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 14px;
  width: 100%;

  .radio {
    position: relative;
    flex: 1;

    > input {
      display: none;
    }

    .name {
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      border: none;
      border-bottom: none;
      padding: 12px;
      color: var(--color-white);
      background-color: transparent;
      transition: all 0.25s ease-in-out;
      position: relative;
      font-weight: 500;
      white-space: nowrap;
      color: rgba(255, 255, 255, 0.3);
      text-align: center;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    input:checked + .name {
      color: var(--color-white);
      background-color: transparent;
      margin-bottom: -1px;
      z-index: 1;
      animation: fadeIn 0.3s ease-in-out;
    }

    input + .name:hover {
      color: var(--color-white);
    }

    input:checked + .name:hover {
      color: var(--color-white);
    }

    input + .name::after {
      content: '';
      position: absolute;
      height: 2px;
      background-color: rgba(255, 255, 255, 0.3);
      bottom: 0;
      left: 0;
      right: 0;
      transition: all 0.3s ease;
    }

    input:checked + .name::after {
      content: '';
      position: absolute;
      height: 2px;
      background-color: var(--color-white);
      bottom: 0;
      left: 0;
      right: 0;
      animation: lineExpand 0.3s ease-in-out;
    }

    input:checked + .name::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: transparent;
      bottom: -1px;
      left: 0;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0.5;
      transform: translateY(2px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes lineExpand {
    0% {
      left: 50%;
      right: 50%;
      opacity: 0;
    }
    100% {
      left: 0;
      right: 0;
      opacity: 1;
    }
  }
`;
